// Alegerea temei, într-un singur loc, folosită din trei.
//
// Temele stăteau doar în setările screener-ului — adică ascunse după patru clicuri, iar
// pe telefon deloc, fiindcă acolo screener-ul e alt ecran. Culoarea aplicaţiei nu e o
// setare de screener, e o setare a aplicaţiei; deci bucata asta trăieşte separat şi se
// pune oriunde e nevoie: în meniul lateral, în meniul de pe telefon, în setările vechi.

import { el, clear } from '../core/util.js';
import { THEMES, applyTheme, currentThemeId } from '../core/theme.js';
import { toast } from './components.js';

/**
 * Lista de teme, ca element gata de pus într-o foaie sau într-un meniu.
 *
 * `laAlegere` se cheamă după schimbare, dacă gazda mai are ceva de împrospătat.
 */
export function listaTeme(laAlegere) {
  const gazda = el('div', { class: 'tema-lista' });

  const deseneaza = () => {
    clear(gazda);
    const activa = currentThemeId();
    for (const tema of THEMES) {
      gazda.append(el('button', {
        class: `tema-rand${tema.id === activa ? ' activa' : ''}`,
        onclick: () => {
          applyTheme(tema.id);
          deseneaza();
          toast(`Тема «${tema.label}»`, 'success');
          laAlegere?.(tema.id);
        },
      }, [
        el('span', { class: 'tema-mostre' }, tema.swatch.map((c) => el('i', { style: { background: c } }))),
        el('span', { class: 'tema-text' }, [
          el('span', { class: 'tema-nume', text: tema.label }),
          el('span', { class: 'tema-hint', text: tema.hint }),
        ]),
        el('span', { class: 'tema-bifa', text: tema.id === activa ? '✓' : '' }),
      ]));
    }
  };

  deseneaza();
  return gazda;
}

/** Deschide alegerea temei ca foaie de jos (telefon) sau fereastră (calculator). */
export async function deschideTeme() {
  const corp = listaTeme();
  const { esteMobil } = await import('../core/device.js');
  if (esteMobil()) {
    const { foaie } = await import('./sheet.js');
    foaie({ titlu: 'Тема оформления', corp });
    return;
  }
  const { modal } = await import('./components.js');
  modal({ title: 'Тема оформления', width: 460, body: corp, actions: [] });
}
